import { useCurrentTeam } from "feature/session/hook/useCurrentTeam";
import { useFindOrFetchSubscription } from "domain/subscription/hook/useFindOrFetchSubscription";

export const useCurrentSubscription = () => {
  const currentTeam = useCurrentTeam();
  return useFindOrFetchSubscription(currentTeam?.subscription_id);
};
